import ConfirmationDialog, { ConsequencesList } from './ConfirmationDialog';
import LosingChangesConfimationDialog from './LosingChangesConfimationDialog';
import { useLanguage } from '../contexts/language';
import { ListElement } from '../hooks/useDraftList';
import { CrewMemberCertificate } from '../types/crew';
import { VesselCertificate } from '../types/vessel';
import {
  CrewMemberCertificateStatus,
  VesselCertificateStatus,
} from '../types/core';

export interface DeleteCertificateConfirmationDialogProps {
  certificateItem: ListElement<
    CrewMemberCertificate | VesselCertificate
  > | null;
  isLoading: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const DeleteCertificateConfirmationDialog = ({
  isLoading,
  onClose,
  onConfirm,
  certificateItem,
}: DeleteCertificateConfirmationDialogProps) => {
  const { t } = useLanguage();

  const isRejectedCertificate =
    certificateItem &&
    !certificateItem.isDraft &&
    [
      CrewMemberCertificateStatus.Rejected,
      VesselCertificateStatus.Rejected,
    ].includes(certificateItem.data.status);

  return (
    <>
      <LosingChangesConfimationDialog
        isOpen={Boolean(certificateItem && certificateItem.isDraft)}
        onConfirm={onConfirm}
        onClose={onClose}
      />
      <ConfirmationDialog
        open={Boolean(certificateItem && !certificateItem.isDraft)}
        onClose={onClose}
        onConfirm={onConfirm}
        loading={isLoading}
        title={
          !isRejectedCertificate
            ? t('content.certificate-deletion-confirmation.non-rejected.title')
            : t('content.certificate-deletion-confirmation.rejected.title')
        }
      >
        {certificateItem && !certificateItem.isDraft && (
          <ConsequencesList
            action={
              !isRejectedCertificate
                ? t(
                    'content.certificate-deletion-confirmation.non-rejected.action',
                  )
                : t('content.certificate-deletion-confirmation.rejected.action')
            }
            list={
              !isRejectedCertificate
                ? [
                    t(
                      'content.certificate-deletion-confirmation.non-rejected.bullet-points.certificate-no-longer-available',
                    ),
                    t(
                      'content.certificate-deletion-confirmation.non-rejected.bullet-points.submitted-journeys-will-be-reverted',
                    ),
                    t(
                      'content.certificate-deletion-confirmation.non-rejected.bullet-points.invoiced-journeys-unnafected',
                    ),
                  ]
                : [
                    t(
                      'content.certificate-deletion-confirmation.rejected.bullet-points.certificate-no-longer-visible',
                    ),
                  ]
            }
          />
        )}
      </ConfirmationDialog>
    </>
  );
};

export default DeleteCertificateConfirmationDialog;
